import { formatProductPrice }    from '../../../../shared/utils/index.js'
import { PRODUCT_ATTRIBUTE_IDS } from '../../../../shared/constants/productAttributes.js'

import { StatusBadge }           from '../../../../shared/ui/StatusBadge/StatusBadge.jsx'

import { ProductActionsCell } from './ProductActionsCell.jsx'
import { ProductInquiryCell } from './ProductInquiryCell.jsx'
import { ProductPriceCell } from './ProductPriceCell.jsx'


// ── Constants ─────────────────────────────────────────────────────────────────

export const DEFAULT_COLUMN_WIDTH = '8em'

/**
 * Width of a single action icon button (em).
 * No compounding risk — .cell no longer sets font-size, so 1em = --bim-base.
 */
const ICON_SIZES = {
    small:  "2",    //em
    medium: "2.5",  //em
    large:  "3"     //em
  }

export const ACTION_ICON_SIZE = "small"
/** Gap between action buttons inside the actions cell (em). */
const ACTION_GAP =      0.25 // em
/** Horizontal cell padding in em (must mirror $cell-padding-h in RecordTable). */
const CELL_PADDING_H =  0.75 // em

// ── UI MAP ─────────────────────────────────────────────────────────────────

export const LIST_COLUMN_UI_MAP = { //TODO: should this use DATA_ITEMS_IDS or PRODUCT_ATTRIBUTE_IDS directly????
  [PRODUCT_ATTRIBUTE_IDS.ID_CAD]: {
    width: 'minmax(8em, 1fr)',
    align: 'center',
  },

  [PRODUCT_ATTRIBUTE_IDS.BUILDING_ID]: {
    width: '8em',
    align: 'center',
  },

  [PRODUCT_ATTRIBUTE_IDS.GATE]: {
    width: '8em',
    align: 'center',
  },

  [PRODUCT_ATTRIBUTE_IDS.REF_TIER]: {
    width: '8em',
    align: 'center',
  },

  [PRODUCT_ATTRIBUTE_IDS.ROOMS]: {
    width: '8em',
    align: 'center',
  },

  [PRODUCT_ATTRIBUTE_IDS.AREA]: {
    width: '8em',
    align: 'center',
  },

  [PRODUCT_ATTRIBUTE_IDS.STATUS]: {
    width: 'minmax(10em, 1fr)',
    align: 'center',
    render: (p) => <StatusBadge status={p.status ?? 'unknown'} size="small" />,
  },

  [PRODUCT_ATTRIBUTE_IDS.PRICE]: {
    width: 'minmax(12em, 1fr)',
    align: 'center',
    render: (p, context) => <ProductPriceCell product= {p} context={context} />,
  },

  [PRODUCT_ATTRIBUTE_IDS.ACTIONS]: {
    align: 'center',
    width: (context) => {
      const count = context?.activeActions?.length ?? 0
      if (count === 0) return '0em'
      const w = count * ICON_SIZES[ACTION_ICON_SIZE] + Math.max(0, count - 1) * ACTION_GAP + 2 * CELL_PADDING_H
      return `${w}em`
    },
    render: (p, context) => <ProductActionsCell product={p} context={context} />,
  },
  
  [PRODUCT_ATTRIBUTE_IDS.INQUIRY]: {
    align: 'center',
    width: `${1.5 + 2 * CELL_PADDING_H}em`,
    render: (p, context) => <ProductInquiryCell product={p} />,
  },
}


